<template>
  <div class="section" id="get-list">
    <h2>GET list</h2>
    <div class="contents local topic" id="contents">
      <ul class="simple">
        <li>
          <a class="reference internal" href="#get-resource-url" id="id1">GET resource URL</a>
        </li>
        <li><a class="reference internal" href="#notes" id="id2">Notes</a></li>
        <li><a class="reference internal" href="#parameters" id="id3">Parameters</a></li>
        <li><a class="reference internal" href="#request-example" id="id4">Request example</a></li>
        <li>
          <a class="reference internal" href="#response-examples" id="id5">Response example</a>
        </li>
      </ul>
    </div>
    <p>
      List the images present in your API. By default <em>GET list</em> returns information about 20
      images for each call.
    </p>
    <div class="section" id="get-resource-url">
      <h3>GET resource URL</h3>
      <div class="highlight-python">
        <div class="highlight">
          <pre><span></span>https://matchengine.tineye.com/&lt;company&gt;/rest/list/</pre>
        </div>
      </div>
    </div>
    <list-method-widget
      :username="username"
      :password="password"
      :user-url-base="userUrlBase"
      :proxy-url-base="proxyUrlBase"
      :language="language"
      @language-change="language = $event"
      >Interactive example</list-method-widget
    >

    <div class="section" id="notes">
      <h3>Notes</h3>
      <p>
        The list method’s output order is stable, so you can use <cite>offset</cite> and
        <cite>limit</cite> to implement pagination.
      </p>
    </div>
    <div class="section" id="parameters">
      <h3>Parameters</h3>
      <p>
        In addition to the
        <router-link class="reference internal" to="../api_reference#common-parameters"
          ><span>common parameters</span></router-link
        >
        there are:
      </p>
      <table border="1" class="docutils">
        <colgroup>
          <col width="32%" />
          <col width="68%" />
        </colgroup>
        <thead valign="bottom">
          <tr class="row-odd">
            <th class="head">Key</th>
            <th class="head">Description</th>
          </tr>
        </thead>
        <tbody valign="top">
          <tr class="row-even">
            <td><strong>offset</strong><em> (optional)</em></td>
            <td>
              Skips that many images in the collection, defaults to <cite>0</cite>.
              <cite>0</cite> means to not skip any items. Should be at least <cite>0</cite>.
            </td>
          </tr>
          <tr class="row-odd">
            <td><strong>limit</strong><em> (optional)</em></td>
            <td>
              Limits the results to this many images, defaults to <cite>20</cite>.
              <cite>0</cite> will return all items. Should be at least <cite>0</cite>.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="section" id="request-example">
      <h3>Request example</h3>
      <div class="highlight-bash">
        <div class="highlight">
          <pre><span></span>curl https://matchengine.tineye.com/&lt;company&gt;/rest/list/ --get     <span class="se">\</span>
         -d <span class="s2">"offset=1"</span>                                                <span class="se">\</span>
         -d <span class="s2">"limit=3"</span></pre>
        </div>
      </div>
    </div>
    <div class="section" id="response-examples">
      <h3>Response example</h3>
      <div class="section" id="json">
        <div class="highlight-json response">
          <div class="highlight">
            <pre><span></span><span class="p">{</span>
      <span class="nt">"status"</span><span class="p">:</span> <span class="s2">"ok"</span><span class="p">,</span>
      <span class="nt">"method"</span><span class="p">:</span> <span class="s2">"list"</span><span class="p">,</span>
      <span class="nt">"error"</span><span class="p">:</span> <span class="p">[],</span>
      <span class="nt">"result"</span><span class="p">:</span> <span class="p">[</span>
        <span class="s2">"path/folder/2.jpg"</span><span class="p">,</span>
        <span class="s2">"path/folder/3.jpg"</span>
      <span class="p">]</span>
    <span class="p">}</span></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListMethodWidget from "@/components/ListMethodWidget.vue";

export default {
  name: "list_method_reference",
  data: function () {
    return {
      language: "python",
      username: "matchengine_user",
      password: "matchengine_password",
      userUrlBase: "https://matchengine.tineye.com/sandbox",
      proxyUrlBase: "/matchengine_sandbox",
    };
  },
  components: {
    ListMethodWidget,
  },
};
</script>
